import React from 'react';
import { Modal, ModalFooter } from 'reactstrap';
import './index.css';

const RejectMultipleOrderConfirmModal = ({ isOpen, toggle, rejectOrder }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      id="AcceptOrderConfirmModal"
    >
      <div className="bodyArea">
        Are you sure want to reject multiple products?
      </div>
      <ModalFooter>
        <button className="customButton" onClick={toggle}>
          No
        </button>
        <button
          className="customButton customButton_blue"
          onClick={rejectOrder}
        >
          Yes
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default RejectMultipleOrderConfirmModal;
